/**
 * UpsellEvents — module-scoped event bus for 402 "feature_not_entitled"
 * responses caught by the axios interceptor.
 *
 * Why a bus and not a context?
 *   • The axios interceptor lives outside the React tree.
 *   • A single global modal mounted in App.jsx subscribes once and pops
 *     for ANY API call that hits 402 — no per-component plumbing.
 *   • Same pattern as CreditWallEvents (which already proved itself
 *     for the 429 case).
 *
 * Payload: { feature_key, addon_plan_id (optional), source_url }
 */

const listeners = new Set();

export function onUpsellEvent(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function emitUpsellEvent(payload) {
  for (const cb of listeners) {
    try { cb(payload); } catch { /* listener errors are isolated */ }
  }
}
